import { $themeColors } from '@themeConfig'

export const getIconColor = label => {
  const labelColor = {
    Male: 'text-danger',
    Female: 'text-primary',
    Others: 'text-warning',

    Active: 'text-primary',
    Dormant: 'text-warning',
    Frozen: 'text-danger',
    Inactive: 'text-dark',
    Closed: 'text-info',
    PNC: 'text-success',
    PND: 'text-secondary',
  }
  return labelColor[label]
}

export const getChartColor = label => {
  const labelColor = {
    Male: $themeColors.danger,
    Female: $themeColors.primary,
    Others: $themeColors.warning,

    Active: $themeColors.primary,
    Dormant: $themeColors.warning,
    Frozen: $themeColors.danger,
    Inactive: $themeColors.dark,
    Closed: $themeColors.info,
    PNC: $themeColors.success,
    PND: $themeColors.secondary,
  }
  return labelColor[label]
}
